module.exports = __webpack_public_path__ + "static/banner-enterprise-3fac6b321ad91e4e823f8fc5bc859735.jpg";